module.exports = __webpack_public_path__ + "media/images/black_bg-7a357cfc63da42e03e46d7809583fe67.png";